import { useEffect, useState } from "react";

import { useEditSettingsMutation } from "@evr/apis/orgSettings";
import { PlanKeys } from "@evr/constant";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectUserOrgSettings, selectUserSubscription } from "@evr/store/slices/auth";
import { CircleLoading } from "@evr/ui/CircleLoading";
import { Flex, RowContainer, Wrapper } from "@evr/ui/FlexBox";
import { ToggleSwitch } from "@evr/ui/ToggleSwitch";
import { Typography } from "@evr/ui/Typography";

export const ToggleEnableRecharge = () => {
  const { planType } = useAppSelector(selectUserSubscription);
  const orgSettings = useAppSelector(selectUserOrgSettings);
  const [enableRecharge, setEnableRecharge] = useState(orgSettings.enableRecharge);

  useEffect(() => {
    setEnableRecharge(orgSettings.enableRecharge);
  }, [orgSettings]);

  const isFreePlan = planType === PlanKeys.STARTER;

  const [editEnableRecharge, { isLoading }] = useEditSettingsMutation();

  const onChange = (status: boolean) => {
    editEnableRecharge({ ...orgSettings, enableRecharge: status });
  };

  return (
    <RowContainer width="100%" justify="flex-start">
      <Typography>Allow driver to re-route to charger</Typography>
      <Flex margin="0.2rem 0.2rem 0.2rem auto" title={isFreePlan ? "This item is not active on your plan" : ""}>
        <ToggleSwitch
          onChange={onChange}
          loading={isLoading}
          disabled={isFreePlan}
          value={enableRecharge}
          checked={enableRecharge}
        ></ToggleSwitch>
        <Wrapper position="relative">{isLoading && <CircleLoading size={4} />}</Wrapper>
      </Flex>
    </RowContainer>
  );
};
